import { render, staticRenderFns } from "./Frame1.vue?vue&type=template&id=28b06d6c&scoped=true&"
import script from "./Frame1.vue?vue&type=script&lang=js&"
export * from "./Frame1.vue?vue&type=script&lang=js&"
import style0 from "./Frame1.vue?vue&type=style&index=0&id=28b06d6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b06d6c",
  null
  
)

export default component.exports